import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ImageEditorModalComponent } from '../image-editor/image-editor-modal/image-editor-modal.component';
import { FileType, FileReaderService } from 'src/app/services/file-reader.service';
import { ImageResizeService } from 'src/app/services/image-resize.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-input-img-laudo',
  templateUrl: './input-img-laudo.component.html',
  styleUrls: ['./input-img-laudo.component.scss']
})
export class InputImgLaudoComponent implements OnInit {
  @ViewChild(ImageEditorModalComponent, { static: true }) editorModal: ImageEditorModalComponent;

  //@Input() upload: any = async (e) => e;
  //@Input() delete: any = async (e) => '';
  @Input() url: string = '';
  @Input() outputType: 'base64' | 'arrayBuffer' = 'base64';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() invalid: boolean = false;
  @Input() loading: boolean = false;
  @Output() click = new EventEmitter();
  //@Output() urlChange = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();
  @Output() editEvent = new EventEmitter();
  @Output() openLinkEvent = new EventEmitter();
  @Output() saveEvent = new EventEmitter();
  fileInput: any;
  base64: string = '';

  @Input() showEditBtn = true;
  @Input() showDeleteBtn = true;
  @Input() showLinkBtn = true;

  erroImg = false;

  constructor(private msgService: ModalMsgService, private fileReaderService: FileReaderService, private imageResizeService: ImageResizeService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    if(this.url != ''){
      this.url = environment.wsUrl+"consulta/getImagem?urlImagem="+this.url;
    }
  }
  erroImgEvent() {
    this.erroImg = true;
  }

  openLink() {
    this.openLinkEvent.emit();
  }

  openEditor() {
    this.imgUrlToBase64().then(() => this.editorModal.open());
  }

  btnClick(popoverElement) {
    this.erroImg = false;
    if (this.disabled || this.loading) return;

    if(this.url.toString() == 'true' || this.url.toString() == 'false') {
      this.url = '';
    }

    if (this.url) {
      popoverElement.open();
    }

    if (!this.url) {
      this.selectFile();
    }
  }

  imgUrlToBase64():Promise<any> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        let canvas = document.createElement('CANVAS') as HTMLCanvasElement;
        let ctx = canvas.getContext('2d');
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        this.base64 = canvas.toDataURL();
        canvas = null;
        img = null;
        resolve(null);
      };
      img.src = this.url;
    });
  }

  selectFile() {
    let input: HTMLElement = document.createElement('input') as HTMLInputElement;
    input.setAttribute('type', 'file');
    input.setAttribute('accept', FileType.image);
    input.onchange = (e: any) => {
      this.setImageFile(e.target.files);
      this.cd.markForCheck();
      input.remove();
      this.aguardar(2000);
    }
    input.click();

  }

  async setImageFile(files) {

    for (let i = 0; i < files.length; i++) {
      let file = files[i];

      if(['image/jpeg','image/png', 'image/tiff', 'image/pjpeg', 'image/pjp'].find( t => t == file.type)) {
        let image = await this.fileReaderService.readAsDataUrl(file);
        image = await this.imageResizeService.resize(image);
        this.saveEvent.emit(image)
      }else {
        this.msgService.openDialog('Tipo não suportado!', 'O arquivo ' + file.name + ' não é uma imagem válida', 'danger').then( r => r ).catch( r => r );
        return;
      }
    }
  }

  uploadImage(img) {
    this.editEvent.emit(img);
  }

  deleteImage() {
    this.deleteEvent.emit(true);
    this.url = '';
    this.aguardar(2000);
  }

  setImageBase64(img) {
    this.editEvent.emit(img);
    this.base64 = '';
  }

  aguardar(milisegundos) {
    setTimeout(function () {
      var botoes = document.getElementById("btnM");
      botoes.click();
    }, milisegundos);
  }

}
